import { PresentationalCheckboxGroup } from '@opendoor/bricks/core';
import { useState } from 'react';
import { FollowupQuestions } from 'sellDirect/components/closingDash/disclosures/DynamicDisclosures/FollowupQuestions';
import { BaseQuestion } from 'sellDirect/components/closingDash/disclosures/DynamicDisclosures/BaseQuestion';
import {
  Prompt,
  PromptGroup,
  SelectedOptions,
  getOptions,
  areOptionsSelected,
  PromptResponse,
} from 'sellDirect/helpers/closingDash/disclosures';

export interface MultiSelectQuestionProps {
  question: Prompt;
  promptGroup: PromptGroup;
  onResponseChange: (value: PromptResponse | null) => void;
  showErrors?: boolean;
}

/**
 * Creates multi select option question component
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const MultiSelectQuestion: React.FC<MultiSelectQuestionProps> = ({
  question,
  promptGroup,
  onResponseChange,
  showErrors,
}) => {
  const [groupOptions, setGroupOptions] = useState(getOptions(question));
  const isComplete = areOptionsSelected(question);
  const errorMessage = showErrors && !isComplete ? 'Required' : undefined;

  const onUpdate = (question: Prompt, value?: string) => {
    if (value) {
      let current_selected_options =
        (question.response as SelectedOptions)?.selectedOptions?.values || [];

      if (current_selected_options?.includes(value)) {
        current_selected_options = current_selected_options.filter((o) => o != value);
      } else {
        current_selected_options.push(value);
      }

      setGroupOptions(getOptions(question, current_selected_options));

      const response: SelectedOptions | null =
        current_selected_options.length > 0
          ? {
              __typename: 'OdProtosRubricV2Data_Prompt_ResponseOneof_SelectedOptions',
              selectedOptions: {
                values: current_selected_options,
                __typename: 'OdProtosRubricV2Data_SelectedOptions',
              },
            }
          : null;
      onResponseChange(response);
    }
  };

  return (
    <>
      <BaseQuestion question={question}>
        <PresentationalCheckboxGroup
          options={groupOptions}
          name={question.id}
          analyticsName={question.id}
          hasContainer={true}
          errorMessage={errorMessage}
          onClick={(value) => onUpdate(question, value)}
        />
      </BaseQuestion>
      <FollowupQuestions question={question} promptGroup={promptGroup} showErrors={showErrors} />
    </>
  );
};
